/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { ReadAnnouncementsApiResponse } from '../types/uploadsApi.types';

const extensionPattern = /\..{2,5}$/;

export function transformReadAnnouncementsResponse(
  response: any,
): ReadAnnouncementsApiResponse {
  return {
    data: {
      uploads: response.data.uploads.map((announcement) => {
        const name = announcement.url.split('/').at(-1) ?? '';
        return {
          ...announcement,
          name,
          id: name.replace(extensionPattern, ''),
        };
      }),
    },
    meta: {},
  };
}
